import React from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripHorizontal } from "@fortawesome/free-solid-svg-icons";
import "../../styles/common-components/DraggableList.css";

const DraggableList = ({
  onDragEnd,
  dataItems,
  showIndex = false,
}) => {
  return (
    <div className="draggable-wrapper">
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={`draggable-list ${snapshot.isDraggingOver ? 'draggable-list-dragging-over' : ''}`}
            >
              {dataItems.map((item, index) => (
                <Draggable key={item._id} draggableId={item._id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      key={item._id}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={`draggable-item ${snapshot.isDragging ? 'draggable-item-dragging' : ''}`}
                      style={provided.draggableProps.style}
                    >
                      <div className="draggable-item-content">
                        {showIndex && <span>{index + 1}.</span>}
                        <span className="draggable-item-name">{item.name}</span>
                        {item.designation && (
                          <span className="draggable-item-designation">
                            ({item.designation})
                          </span>
                        )}
                      </div>
                      <FontAwesomeIcon
                        size="lg"
                        icon={faGripHorizontal}
                        className="draggable-item-icon"
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default DraggableList;